import { useEffect, useState } from 'react';

// A run past this point says so in the status line ("Still sending…")
export const STILL_RUNNING_MS = 8000;

export function useStillRunning(running: boolean): boolean {
  const [still, setStill] = useState(false);
  const [wasRunning, setWasRunning] = useState(running);
  if (running !== wasRunning) {
    setWasRunning(running);
    setStill(false);
  }
  useEffect(() => {
    if (!running) return;
    const timer = setTimeout(() => setStill(true), STILL_RUNNING_MS);
    return () => clearTimeout(timer);
  }, [running]);
  return running && still;
}
